class DrawerCart extends HTMLElement {
  constructor() {
    super();
  }


  renderContents(parsedState) {
      // this.productId = parsedState.id;
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {

        if (section.class) {
          // console.log('\n\n\ncart-notification.js1: IF section.class');
          // console.log('cart-notification.js1: section.class: ' + section.class);
          // console.log('cart-notification.js1: section.selector: ' + section.selector);
          // console.log('cart-notification.js1: section.section: ' + section.section);
          // console.log('cart-notification.js1: section.id: ' + section.id);

          document.querySelectorAll(section.class).forEach((item) => {
            // document.getElementById(section.id).innerHTML =
            //   this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
            // console.log('item');
            // console.log(item);
            // console.log('1 document.querySelector(section.selector)');
            // console.log(document.querySelector(section.selector));

            item.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          });
        } else {
          // console.log('\n\n\ncart-notification.js2: ELSE section.class');
          // console.log('cart-notification.js2: section.selector: ' + section.selector);
          // console.log('cart-notification.js2: section.section: ' + section.section);
          // console.log('cart-notification.js2: section.id: ' + section.id);

          // console.log('2 document.querySelector(section.selector)');
          // console.log(document.querySelector(section.selector));

          document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }

      }));

      if (this.header) this.header.reveal();
      efmCart.openCart();
      checkFreeGifts();
  }

  /*
    ID = the parent id where you want the content to be placed
    SECTION = the name of the section
    SELECTOR = inside the section, the id="" wrapping the innerHTML that you want placed inside ID

    example input:
      id="cart-icon-bubble"
      section/cart-icon-bubble
      selector="cart-icon-bubble-replace"
    example output:
      this will look in section/cart-icon-bubble, take the innerHTML of id="cart-icon-bubble-replace", and insert it into id="cart-icon-bubble"
  */

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble-replace'
      },
      {
        id: 'cart-icon-bubble-utility',
        section: 'cart-icon-bubble-utility',
        selector: '#cart-icon-bubble-utility-replace'
      },
      {
        id: 'main-cart-items',
        section: 'main-cart-items',
        selector: '.js-contents-cart-items',
        class: '.main-cart-items'
      },
      {
        id: 'main-cart-footer',
        section: 'main-cart-footer',
        selector: '#main-cart-footer-insert',
        class: '.main-cart-footer'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

}

customElements.define('drawer-cart', DrawerCart);
